// App constants and configuration
export const ROUTES = {
  // Public routes
  HOME: '/',
  WORLD_CUP_SCHEDULE: '/wc/schedule',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  
  // Protected routes
  BRACKET: '/bracket',
  LEADERBOARD: '/leaderboard',
  LEAGUES: '/leagues',
  LEAGUE_DETAIL: '/leagues/:id',
  PROFILE: '/profile',
  SCOUT: '/scout',
  STORE: '/store',
  CHALLENGES: '/challenges',
  PREMIUM: '/premium',
  POOLS: '/pools',
  
  // Admin routes
  ADMIN: '/admin',
} as const;

export const COLORS = {
  primary: '#FF6B35',
  secondary: '#4ECDC4',
  accent: '#45B7D1',
  success: '#00D084',
  warning: '#FFC107',
  error: '#E53E3E',
  info: '#3182CE',
  
  // Dark theme colors
  background: '#0F0F23',
  surface: '#1A1A3A',
  surface2: '#252547',
  text: {
    primary: '#FFFFFF',
    secondary: '#A0AEC0',
    muted: '#68707B',
  },
  
  // Bracket specific colors
  bracket: {
    eliminated: '#4A5568',
    selected: '#FF6B35',
    unselected: '#2D3748',
    correct: '#00D084',
    incorrect: '#E53E3E',
    locked: '#68707B',
  }
} as const;

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const;

const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL;

export const API_BASE_URL =
  configuredApiBaseUrl ||
  (import.meta.env.DEV
    ? 'http://localhost:3001/api/v1'
    : 'https://bracketblitz-production.up.railway.app/api/v1');

// Feature flags
export const USE_MOCK_DATA = String(import.meta.env.VITE_USE_MOCK_DATA || '').toLowerCase() === 'true';

export const BRACKET_CONFIG = {
  totalGames: 63,
  regions: ['east', 'west', 'south', 'midwest'] as const,
  rounds: [
    { name: 'First Round', games: 32 },
    { name: 'Second Round', games: 16 },
    { name: 'Sweet Sixteen', games: 8 },
    { name: 'Elite Eight', games: 4 },
    { name: 'Final Four', games: 2 },
    { name: 'Championship', games: 1 },
  ] as const,
  confidence: {
    min: 1,
    max: 10,
    default: 5,
  },
  lockTime: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
} as const;

export const ANIMATION_DURATIONS = {
  fast: 150,
  normal: 300,
  slow: 500,
} as const;
